import { useState } from "react";
import { useZxing } from "react-zxing";

export const BarcodeScanner = () => {
    const [result, setResult] = useState("");
    const { ref } = useZxing({
        onResult(result) {
            setResult(result.getText());
        },
    });

    return (
        <div className="video-inner-div">
            <video ref={ref} />
        </div>
    );
};